import CertsTerminateModal from './CertsTerminateModal';

export default CertsTerminateModal;
